// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles-module--logo-container--MwbYg","logoMargin":"styles-module--logo-margin--3QedO","wrapper":"styles-module--wrapper--2spd3"};